export default __webpack_public_path__ + "static/media/Inter-ExtraBoldItalic.941baf7c.woff";